<template>
  <div class="m-container">
    <m_header></m_header>
    <div class="m-content" style="width: 1200px; margin: 40px auto;">
      <!-- 商品列表 -->
      <div class="product-list">
        <div
          class="product-item"
          v-for="(item) in dataList"
          :key="item.id"
          @click="openBuy"
        >
          <div class="product-image">
            <img :src="item.img" :alt="item.title">
          </div>
          <div class="product-info">
            <h3 class="product-title">{{ item.title }}</h3>
            <div class="product-price">¥{{ item.money }}</div>
            <div class="product-sales">已售 {{ item.number }} 件</div>
          </div>
        </div>
      </div>
    </div>
    <m_bottom></m_bottom>

    <!-- 地址弹窗 -->
    <el-dialog title="请输入收货地址" :visible.sync="openState" @close='closeDialog' width="650px" center>
      <div class="m-open-container">
        <div class="zs-open-body-ov" style="margin-right: 40px;">
          <el-form :model="form" :rules="rules" ref="form" label-width="110px">
            <el-form-item label="姓名: " prop="name">
              <el-input v-model="form.name" placeholder="输入您的姓名"></el-input>
            </el-form-item>
            <el-form-item label="电话: " prop="phone">
              <el-input v-model="form.phone" placeholder="输入您的电话"></el-input>
            </el-form-item>
            <el-form-item label="所在地区: " prop="selectedOptions">
              <div>
                <el-cascader
                  size="large"
                  :options="options"
                  v-model="selectedOptions"
                  @change="handleChange"
                >
                </el-cascader>
              </div>
            </el-form-item>
            <el-form-item label="详细地址: " prop="address">
              <el-input v-model="form.address" placeholder="输入您的详细地址"></el-input>
            </el-form-item>
            <el-form-item label="标签: " prop="agreementType">
              <el-checkbox-group v-model="checkList">
                <el-checkbox label="家"></el-checkbox>
                <el-checkbox label="公司"></el-checkbox>
                <el-checkbox label="学校"></el-checkbox>
                <el-checkbox label="其他"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="设为默认地址: " prop="agreementType">
              <el-switch
                v-model="switchValue">
              </el-switch>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="openState = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 支付弹窗 -->
    <el-dialog title="请扫码支付" :visible.sync="openBuyState" @close='closeDialog' width="650px" center>
      <div class="m-open-container" style="margin-bottom: 40px;">
        <div style="text-align: center;">
          六十甲子订单 <span>收款方：北京六十甲子系统科学研究院有限公司</span>
        </div>
        <div class="m-open-buy-opt">
          <div @click="selectBuyType(0)" class="m-open-buy-opt-item" :class="buyType === 0 ? 'm-open-buy-opt-at' : ''">
            <img src="../assets/img/zhifubao.gif" alt="">
            <div v-if="buyType === 0" class="m-open-buy-opt-at-tip"><i class="el-icon-s-finance"></i></div>
          </div>
          <div @click="selectBuyType(1)" class="m-open-buy-opt-item" :class="buyType === 1 ? 'm-open-buy-opt-at' : ''">
            <img src="../assets/img/weixin.gif" alt="">
            <div v-if="buyType === 1" class="m-open-buy-opt-at-tip"><i class="el-icon-s-finance"></i></div>
          </div>
        </div>
        <div class="m-open-buy-code">
          <img v-if="buyType === 0 && buyLoading === false" src="../assets/img/zfb.jpg" alt="">
          <img v-if="buyType === 1 && buyLoading === false" src="../assets/img/weixin.jpg" alt="">
          <div v-if="buyLoading" class="m-open-buy-code-load" v-loading="buyLoading"></div>
        </div>
        <div style="text-align: center;margin-top: 20px;">
          <i class="el-icon-full-screen"></i>
          打开手机扫描二维码支付
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { regionData, CodeToText } from 'element-china-area-data'
export default {
  name: 'subclass',
  data () {
    return {
      options: regionData,
      selectedOptions: [],
      listIndex: 0,
      buyType: 0,
      openState: false,
      openBuyState: false,
      switchValue: false,
      buyLoading: false,
      form: {
        name: '',
        city: '',
        address: '',
        phone: ''
      },
      optionIndex: 'operate',
      checkList: [],
      dataList: [
        {id: '1', img: require('../assets/img/book1.jpg'), title: '黄铜猪摆件白菜猪家居客厅玄关办公室摆设生肖猪店铺乔迁开业礼品', number: 89, money: 544.2},
        {id: '2', img: require('../assets/img/book2.jpg'), title: '新中式柿柿如意铜件摆件黄铜万事葫芦事事办公室老板桌面高档大气', number: 59, money: 539.9},
        {id: '3', img: require('../assets/img/book3.jpg'), title: '中式禅意循环流水喷泉招财摆件客厅办公室桌面雾化加湿器开业礼品', number: 69, money: 539},
        {id: '4', img: require('../assets/img/book4.jpg'), title: '招财陶瓷猫摆件创意可爱猫咪吉祥物家居办公桌面装饰工艺品礼品', number: 49, money: 532},
        {id: '5', img: require('../assets/img/book5.jpg'), title: '北欧客厅流沙漏画玄关鹿摆件电视柜酒柜结婚搬家平安喜乐乔迁礼品', number: 89, money: 558},
        {id: '6', img: require('../assets/img/book6.jpg'), title: '全铜梅花鹿摆件 长辈领导送礼居酒柜装饰品客厅玄关新中式工艺品', number: 79, money: 848},
        {id: '7', img: require('../assets/img/book7.jpg'), title: '大吉大利黄铜工艺品大公鸡铜摆件中式客厅玄关装饰品开业礼品刻字', number: 39, money: 936.2},
        {id: '8', img: require('../assets/img/book8.jpg'), title: '从文实木衣柜卧室家用现代简约挂衣柜收纳柜简易组装儿童衣橱定制', number: 59, money: 2638},
        {id: '9', img: require('../assets/img/book9.jpg'), title: '实木衣柜家用卧室出租房屋用推拉门衣橱宝宝儿童新款民宿收纳柜子', number: 89, money: 3320},
        {id: '10', img: require('../assets/img/book10.jpg'), title: '分段式烤漆大衣柜家用卧室衣橱小户型简约现代亮光对开门储物柜子', number: 89, money: 2349},
        {id: '11', img: require('../assets/img/book11.jpg'), title: '意式极简罗奇堡沙发写意空间设计师创意直排大小户型简约布艺沙发', number: 49, money: 2459},
        {id: '12', img: require('../assets/img/book12.jpg'), title: '新中式乌金木沙发全实木现代中式客厅简约布艺储物小户型实木沙发', number: 29, money: 15668},
        {id: '13', img: require('../assets/img/book13.jpg'), title: '沙发磨砂布真皮磨砂皮侘寂风沙发意大利巧克力意式极简沙发', number: 69, money: 4359.3},
        {id: '14', img: require('../assets/img/book14.jpg'), title: '新中式电表箱遮挡挂画配电箱电闸盒装饰画餐厅墙面客厅免打孔壁画', number: 99, money: 1699},
        {id: '15', img: require('../assets/img/book15.jpg'), title: '百特好个性创意上上签装饰画进门玄关挂画书房办公桌斗柜墙画壁', number: 49, money: 359.8},
        {id: '16', img: require('../assets/img/book16.jpg'), title: '八骏图马到成功墙壁画客厅挂画山水画新中式装饰画办公室国画', number: 89, money: 739.8},
        {id: '17', img: require('../assets/img/book17.jpg'), title: '意式简约现代黑色岩板餐桌椅组合长方形复古小户型侘寂风家用餐桌', number: 29, money: 2342},
        {id: '18', img: require('../assets/img/book18.jpg'), title: '全托底板依诺岩板餐桌亮光纯白家用小户型极简轻奢家庭饭桌桌子', number: 39, money: 2559.8},
        {id: '19', img: require('../assets/img/book19.jpg'), title: '实木奶油风岩板餐桌椅小户型现代简约原木长方形桌吃饭桌轻奢桌子', number: 89, money: 1859.8},
        {id: '20', img: require('../assets/img/book20.jpg'), title: '仿真樱花树大型室内装饰假树 网红许愿树 客厅商场影楼落地摆设', number: 49, money: 569.8},
        {id: '21', img: require('../assets/img/book21.jpg'), title: '轻奢现代高档仿真花假花摆设KTV包厢客厅餐桌装饰品干花插花摆件', number: 69, money: 539.8},
        {id: '22', img: require('../assets/img/book22.jpg'), title: '风原创手扎假花花束仿真花装饰摆件高级仿生花餐桌花摆花绢花', number: 79, money: 589.8},
        {id: '23', img: require('../assets/img/book23.jpg'), title: '仿真红色桃花树大型室内外装饰新年红包许愿树树网红发财树摆件', number: 49, money: 569.8},
        {id: '24', img: require('../assets/img/book24.jpg'), title: '代简约双人床出租房用经济型1.2m单人带软包床架', number: 69, money: 3559.8}
      ],
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        city: [
          { required: true, message: '请选择所属地区', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    let id = this.$route.params.id
    for (let i = 0; i < this.dataList.length; i++) {
      if (this.dataList[i].id === id) {
        this.listIndex = i
      }
    }
  },
  methods: {
    toInfoBack () {
      this.$router.back()
    },
    selectBuyType (type) {
      this.buyLoading = true
      this.buyType = type
      setTimeout(() => {
        this.buyLoading = false
      }, 1000)
    },
    handleChange () {
      let loc = ''
      for (let i = 0; i < this.selectedOptions.length; i++) {
        loc += CodeToText[this.selectedOptions[i]]
      }
      this.city = loc
    },
    closeDialog () {
    },
    submit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.openState = false
          this.openBuyState = true
          this.buyLoading = true
          setTimeout(() => {
            this.buyLoading = false
          }, 1000)
        } else {
          return false
        }
      })
    },
    openBuy () {
      this.openState = true
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
.product-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  padding: 20px 0;
}

.product-item {
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.product-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.15);
}

.product-image {
  height: 280px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9f9f9;
}

.product-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.product-info {
  padding: 15px;
}

.product-title {
  font-size: 14px;
  color: #333;
  margin: 0 0 10px 0;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.product-price {
  font-size: 18px;
  color: #ff4444;
  font-weight: bold;
  margin-bottom: 5px;
}

.product-sales {
  font-size: 12px;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/SubclassListInfo.vue